import RechercheElemPatri from '../RechercheElemPatri';
import { PLANIFICATION_STATUS, PROFIL, REQUEST_PASS_TYPE, TRJT_TYPE } from '../../../constants/enum';
import MyButton from '../../Layout/MyButton';
import { faCheck, faEnvelopeOpenText, faPlus, faXmark } from '@fortawesome/free-solid-svg-icons';
import React, { useEffect, useState } from 'react';
import TrajetDescrComponent from './StepComponents/TrajetDescrComponent';
import FormControlLabel from '@mui/material/FormControlLabel';
import RadioGroup from '@mui/material/RadioGroup';
import Radio from '@mui/material/Radio';
import FormControl from '@mui/material/FormControl';
import { Accordion, AccordionSummary, TextField } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import MySelect from '../../Layout/MySelect';
import { AccordionContent } from 'semantic-ui-react';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import axios from 'axios';
import { URL_API } from '../../../utils/globalConfig';
import { useAlert } from 'react-alert';
import ControlledTextField from '../../Controlled/RequestPass/ControlledTextField';
import { useDispatch } from 'react-redux';
import { updateInfosCompl, updateTrajetDescr } from '../../../actions/RequestPassAction';

const StepTrajetDescr = (props) => {
    const {
        refs,
        profil,
        elemPatri,
        setElemPatri,
        demandePassageStyle,
        caracConvoi,
        trajetDescr,
        setTrajetDescr,
        complInfo,
        setComplInfo,
        notAbleToChange,
        requestPassId,
        onOpenElemPatri,
        deleteSection,
        frameworkComponents,
        agGridOptions,
        setAgGridOptions,
        createNewSection,
        demandePassage,
        reference,
        validSteps,
        onNextStep,
        user,
        isBuilding,
        datePassage,
        setDatePassage,
    } = props;

    const dispatch = useDispatch();
    const [expandedAller, setExpandedAller] = useState(true);
    const [expandedRetour, setExpandedRetour] = useState(true);
    const editable = (validSteps.step4 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.CLIENT) || notAbleToChange);
    const ajouterEp = validSteps.step4 && (profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE || profil.profil === PROFIL.INTERVENANT || profil.profil === PROFIL.CLIENT);
    const alert = useAlert();

    const getPassType = () => {
        return elemPatri.descr.passType ?? REQUEST_PASS_TYPE.SUPERIEUR;
    };

    const handleChange = (name, value) => {
        dispatch(updateTrajetDescr(name, value));

        // Si on passe du mode aller / retour à aller simple, on vide les champs de retour.
        if (name === 'type' && value === TRJT_TYPE.ALLER_SIMPLE) {
            setDatePassage({
                ...datePassage,
                nbPassageRetour: null,
                nbVehiculeRetour: null
            });
        }
    };

    const trajetUsedInPlanification = (trajetDscrSectionName, typeTrj : "aller" | "retour") => {
        let isPresentInPlanification = false

        demandePassage.planifications?.filter((p) => !p.deleted).forEach((plan) => {
            // On ne fait la vérification que si la planification n'est pas supprimée ET qu'elle n'est pas annulée.
            if (!isPresentInPlanification && plan.metadata.status !== PLANIFICATION_STATUS.CANCELLED)
                isPresentInPlanification = plan.metadata.concernedPath[typeTrj].filter((path) => trajetDscrSectionName === path.numeroSection).length > 0;
        })

        return isPresentInPlanification
    }

    const handleChangeSection = (e, data, indice, name = null, pattern = null, prList = null) => {
        const tmp = [...data];

        if (prList && prList.length >= 1) {
            let prAbs = prList.find(pr => pr.label === e.target.value).value;
            if (e.target.name === 'pointCaracEnter') {
                tmp[indice]['prSectionEnter'] = prAbs;
            } else {
                tmp[indice]['prSectionExit'] = prAbs;
            }
        } else {
            if (e.target.name === 'pointTypeEnter') {
                tmp[indice]['prSectionEnter'] = '';
                tmp[indice]['pointCaracEnter'] = '';
            } else if (e.target.name == 'pointTypeExit') {
                tmp[indice]['prSectionExit'] = '';
                tmp[indice]['pointCaracExit'] = '';
            }
        }

        // Màj du contenu de l'objet tronçon
        if (pattern) {
            const regex = new RegExp(pattern);
            if (e.target.value === '' || regex.test(e.target.value)) {
                tmp[indice][e.target.name] = e.target.value;
            }
        } else {
            tmp[indice][e.target.name] = e.target.value;
        }

        // Sérialisation des changements
        if (name) {
            handleChange(name, tmp);
        }
    };
    const handleChangeSectionCheckbox = (e, data, indice, name = null) => {
        const tmp = [...data];

        tmp.forEach((t, i) => {
            if (i === indice) {
                t[e.target.name] = e.target.checked;
            }
        });

        if (name) {
            handleChange(name, tmp);
        }
    };
    const handleChangeAccordion = (indice, data, name = null) => {
        const tmp = [...data];

        tmp.forEach((t, i) => {
            if (i === indice) {
                t.expanded = !t.expanded;
            }
        });

        if (name) {
            handleChange(name, tmp);
        }
    };

    useEffect(() => {
        if (elemPatri.descr.numeroSection && !elemPatri.isOpen) {
            const section = document.getElementById(`section-paper-${elemPatri.descr.numeroSection}`);
            if (section) {
                section.scrollIntoView(true);
            }
        }
    }, [elemPatri]);

    const sendNotification = () => {
        axios({
            method: 'POST',
            url: `${URL_API}/demande-passage/send-required-action-notification`,
            params: {
                requestPassId: demandePassage.id,
                userAction: user.user_id,
            },
            data: trajetDescr,
        })
        .then((response) => {
            alert.removeAll();
            // if (response.data === false) {
            //     alert.info('Aucun intervenant affecté à ce dossier — la notification n\'a pas pu être envoyée.');
            // } else {
            alert.success('La notification a été envoyée');
            // }
        })
        .catch((error) => {
            alert.removeAll();
            alert.error(error.message);
        });
    };

    return (<div ref={(divRef) => refs.current['step-trajet_descr'] = divRef} className='step'>
        <div className='step-content'>
            {elemPatri.isOpen &&
                <RechercheElemPatri
                    elemPatri={elemPatri}
                    setElemPatri={setElemPatri}
                    trjtType={getPassType()}
                />
            }
            {!elemPatri.isOpen &&
                <div className='step-content-row'>
                    <div className='row' style={{
                        ...demandePassageStyle.rowIntoPaper,
                        flexWrap: 'nowrap',
                        justifyContent: 'space-around',
                        height: '120px',
                    }}>
                        <div className='section-libelle'>Convoi</div>
                        <div style={demandePassageStyle.sectionLibelle}><b>PTAC
                            :</b> {caracConvoi.masseTotaleCharge ? (caracConvoi.masseTotaleCharge / 1000) + ' T' : ''}
                        </div>
                        <div style={demandePassageStyle.sectionLibelle}><b>Longueur
                            :</b> {caracConvoi.longueurCharge ? (caracConvoi.longueurCharge / 1000) + ' M' : ''}
                        </div>
                        <div style={demandePassageStyle.sectionLibelle}><b>Largeur
                            :</b> {caracConvoi.largeurCharge ? (caracConvoi.largeurCharge / 1000) + ' M' : ''}</div>
                        <div style={demandePassageStyle.sectionLibelle}><b>Hauteur
                            :</b> {caracConvoi.hauteurCharge ? (caracConvoi.hauteurCharge / 1000) + ' M' : ''}</div>
                        <div style={demandePassageStyle.sectionLibelle}><b>Chargement
                            :</b> {caracConvoi.natureCharge}</div>
                    </div>

                    <div className='row' style={{
                        ...demandePassageStyle.rowIntoPaper, flexWrap: 'nowrap', justifyContent: 'flex-start',
                    }}>
                        <FormControl style={{ margin: '20px' }}>
                            <label> TRAJET COMPLET : </label>
                        </FormControl>

                        <ControlledTextField
                            label=''
                            type='text'
                            style={{
                                ...demandePassageStyle.textFieldShort,
                                width: '23%',
                                marginLeft: '35px',
                                backgroundColor: 'white',
                            }}
                            autoComplete='off'
                            name='depart'
                            placeholder={'DEPART'}
                            value={trajetDescr.depart || ''}
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            disabled={notAbleToChange}
                        />

                        <ControlledTextField
                            label=''
                            type='text'
                            style={{
                                ...demandePassageStyle.textFieldShort,
                                width: '23%',
                                marginLeft: '35px',
                                backgroundColor: 'white',
                            }}
                            autoComplete='off'
                            name='arrivee'
                            placeholder={'ARRIVEE'}
                            value={trajetDescr.arrivee || ''}
                            onChange={(e) => handleChange(e.target.name, e.target.value)}
                            disabled={notAbleToChange}
                        />

                        <FormControl style={{ margin: '20px' }}>
                            <RadioGroup name='type' value={trajetDescr.type || TRJT_TYPE.ALLER_SIMPLE}
                                        style={{ display: 'flex', flexDirection: 'row' }}
                                        onChange={(e) => handleChange(e.target.name, e.target.value)}>
                                <FormControlLabel value={TRJT_TYPE.ALLER_SIMPLE} control={<Radio />}
                                                  label='ALLER SIMPLE'
                                                  style={requestPassId !== 0 ? { padding: '9px' } : {}}
                                                  disabled={notAbleToChange} />
                                <FormControlLabel value={TRJT_TYPE.ALLER_RETOUR} control={<Radio />}
                                                  label='ALLER / RETOUR'
                                                  style={requestPassId !== 0 ? { padding: '9px' } : {}}
                                                  disabled={notAbleToChange} />
                            </RadioGroup>
                        </FormControl>

                        {requestPassId !== 0 &&
                            <div className={'action-icon'}
                                 style={{ marginRight: '20px' }}
                                 title={'Envoyer une notification de rappel'}>
                                <FontAwesomeIcon onClick={() => sendNotification()} icon={faEnvelopeOpenText} />
                            </div>
                        }
                    </div>

                    <div className='row' style={{ height: 'auto' }}>
                        <Accordion expanded={expandedAller}>
                            <AccordionSummary
                                style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                                }}
                                expandIcon={<ExpandMoreIcon
                                    className={'expand-more-icon'}
                                    onClick={() => setExpandedAller(!expandedAller)}
                                />}
                                onClick={() => setExpandedAller(!expandedAller)}
                            >
                                <label style={{ marginLeft: '30px' }}> Description du trajet ALLER </label>
                            </AccordionSummary>
                            <AccordionContent>
                                <div className='row' style={{
                                    alignContent: 'flex-start',
                                    justifyContent: 'flex-start',
                                    height: 'auto',
                                }}>
                                    {trajetDescr.descr.map((t, i) => (
                                        <TrajetDescrComponent
                                            key={i}
                                            t={t}
                                            i={i}
                                            handleChange={handleChange}
                                            profil={profil}
                                            demandePassageStyle={demandePassageStyle}
                                            handleChangeAccordion={handleChangeAccordion}
                                            requestPassId={requestPassId}
                                            requestPassStatus={demandePassage.id_status}
                                            handleChangeSectionCheckbox={handleChangeSectionCheckbox}
                                            descr={[...trajetDescr.descr]}
                                            retour={false}
                                            trajetDescr={trajetDescr}
                                            complInfo={complInfo}
                                            notAbleToChange={(trajetUsedInPlanification(t.numeroSection, "aller") && profil.profil === PROFIL.CLIENT) || editable}
                                            tronconInPlanification={trajetUsedInPlanification(t.numeroSection, "aller")}
                                            onOpenElemPatri={onOpenElemPatri}
                                            deleteSection={deleteSection}
                                            handleChangeSection={handleChangeSection}
                                            frameworkComponents={frameworkComponents}
                                            agGridOptions={agGridOptions}
                                            setAgGridOptions={setAgGridOptions}
                                            user={user}
                                            reference={reference}
                                            isBuilding={isBuilding}
                                            ajouterEp={ajouterEp}
                                        />),
                                    )}
                                </div>

                                <div className='row' style={{
                                    alignContent: 'flex-start',
                                    justifyContent: 'flex-end',
                                    height: '100px',
                                }}>
                                    {!notAbleToChange &&
                                        <MyButton onClick={() => createNewSection()}
                                                  style={'buttonDefault'}
                                                  label={'Ajouter un tronçon'}
                                                  icon={faPlus}
                                        />}
                                </div>
                            </AccordionContent>
                        </Accordion>

                        {trajetDescr.type === TRJT_TYPE.ALLER_RETOUR &&
                            <Accordion expanded={expandedRetour}>
                                <AccordionSummary
                                    style={{
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        borderBottom: '1px solid rgba(0, 0, 0, 0.2)',
                                    }}
                                    expandIcon={<ExpandMoreIcon
                                        className={'expand-more-icon'}
                                        onClick={() => setExpandedRetour(!expandedRetour)}
                                    />}
                                    onClick={() => setExpandedRetour(!expandedRetour)}
                                >
                                    <label style={{ marginLeft: '30px' }}> Description du trajet RETOUR </label>
                                </AccordionSummary>
                                <AccordionContent>
                                    <div className='row'
                                         style={{
                                             alignContent: 'flex-start',
                                             justifyContent: 'flex-start',
                                             height: 'auto',
                                         }}>
                                        {trajetDescr.descrRetour && trajetDescr.descrRetour.map((t, i) => (
                                            <TrajetDescrComponent
                                                key={i}
                                                t={t}
                                                i={i}
                                                handleChange={handleChange}
                                                profil={profil}
                                                demandePassageStyle={demandePassageStyle}
                                                handleChangeAccordion={handleChangeAccordion}
                                                requestPassId={requestPassId}
                                                requestPassStatus={demandePassage.id_status}
                                                handleChangeSectionCheckbox={handleChangeSectionCheckbox}
                                                descr={[...trajetDescr.descrRetour]}
                                                retour={true}
                                                trajetDescr={trajetDescr}
                                                complInfo={complInfo}
                                                notAbleToChange={(trajetUsedInPlanification(t.numeroSection, "retour") && profil.profil === PROFIL.CLIENT) || editable}
                                                tronconInPlanification={trajetUsedInPlanification(t.numeroSection, "retour")}
                                                onOpenElemPatri={onOpenElemPatri}
                                                deleteSection={deleteSection}
                                                handleChangeSection={handleChangeSection}
                                                frameworkComponents={frameworkComponents}
                                                agGridOptions={agGridOptions}
                                                setAgGridOptions={setAgGridOptions}
                                                user={user}
                                                reference={reference}
                                                isBuilding={isBuilding}
                                                ajouterEp={ajouterEp}
                                            />),
                                        )}
                                    </div>

                                    <div className='row'
                                         style={{
                                             alignContent: 'flex-start',
                                             justifyContent: 'flex-end',
                                             height: '100px',
                                         }}>
                                        {!notAbleToChange &&
                                            <MyButton onClick={() => createNewSection(true)} style={'buttonDefault'}
                                                      label={'Ajouter un tronçon'}
                                                      icon={faPlus} />}
                                    </div>

                                </AccordionContent>
                            </Accordion>
                        }
                    </div>

                    <div className='row' style={{
                        justifyContent: 'flex-end',
                        alignItems: 'flex-end',
                        minHeight: '80px',
                        height: '80px',
                        marginTop: 'auto',
                    }}>
                        {((profil.profil === PROFIL.ADMINISTRATEUR || profil.profil === PROFIL.GESTIONNAIRE) && demandePassage.id !== 0) &&
                            <MyButton
                                style={validSteps['step4'] ? 'buttonRejected' : 'buttonValidation'}
                                label={validSteps['step4'] ? `Rejeter l'étape` : `Valider l'étape`}
                                icon={validSteps['step4'] ? faXmark : faCheck}
                                onClick={() => {
                                    onNextStep(setTrajetDescr, trajetDescr, 4);
                                }}
                            />
                        }
                    </div>
                    <div className='row' style={{ justifyContent: 'flex-start', minHeight: '25px', height: '25px' }}>
                        <p className='paragraphe-condition'>(*): Obligatoire / (1): 1 des champs est obligatoire</p>
                    </div>
                </div>}
        </div>
    </div>);
};

export default StepTrajetDescr;
